( function ( $ ) {
  "use strict";

  //
  // Configure jQuery
  //
  $.ajaxSetup( {
    cache: true
  } );

  //
  // Burger
  //
  $( "div.burger" ).click( function () {
    window.scrollTo( 0, 0 );
    $( this ).toggleClass( "open" );
    $( "body" ).toggleClass( "overflow-hidden" ).toggleClass( "position-fixed" );
  } );

  //
  // Pre-Loader
  //
  $( window ).on( "load", function () { // makes sure the whole site is loaded
    $( ".spinner" ).fadeOut(); // will first fade out the loading animation
    window.setTimeout( function () {
      $( "#preloader" ).fadeOut( "slow" ); // will fade out the white DIV that covers the website.
    }, 350 );
  } );

  //
  // Animations
  //
  $( '[data-animation]' )
    .map( function () {
      return $( this ).data( 'animation' );
    } )
    .get()
    .filter( function ( value, index, self ) {
      return self.indexOf( value ) === index;
    } )
    .forEach( function ( animation ) {
      if ( 'undefined' !== typeof TRAVEKOM_ANIMATIONS[animation] ) {
        $.getScript( TRAVEKOM_ANIMATIONS[animation] );
      }
    } );

  //
  // Animations from Content
  //
  $( '.js-lottie[data-json]' ).each( function(idx, el) {
    var player = lottie.loadAnimation({
      container: el,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: $(el).data('json')
    });

    // IE Fix
    player.addEventListener('data_ready', function() {
      var width = player.animationData.w, height = player.animationData.h;
      if (width && height) {
        $(player.wrapper).css('height', '0')
          .css('padding-top', (height / width) * 100 + '%')
          .addClass('js-aspect-ratio-added');
      }
    });
  });

  //
  // Anchor navigation
  //
  $( '.anchor-nav' ).each( function () {
    var $nav = $( this );

    $( 'body' ).scrollspy( {
      target: this,
      offset: 180
    } );

    $nav.on( 'click', 'a', function ( event ) {
      if ( event.currentTarget.hash !== "" ) {
        event.preventDefault();

        $( 'html, body' ).animate( {
          scrollTop: $( event.currentTarget.hash ).offset().top - 179
        }, 800, function () {
        } );
      }
    } );

    $( document ).on( 'scroll', function () {
      if ( $( this ).scrollTop() >= $nav.parent().position().top ) {
        $nav.parent().addClass( "anchor-nav-shadow" );
      } else if ( $nav.parent().hasClass( "anchor-nav-shadow" ) ) {
        $nav.parent().removeClass( "anchor-nav-shadow" );
      }
    } );
  } );

  //
  //	Contactform focus
  //
  $(document).on('nfFormReady', function() {
    var contactformInputs = $('.contactform input, .contactform select, .contactform textarea');
    contactformInputs.focus(function(evt) {
      $(evt.currentTarget).closest('.field-wrap').addClass('has-focus');
    });
    contactformInputs.blur(function(evt) {
      $(evt.currentTarget).closest('.field-wrap').removeClass('has-focus');
    });
    function setHasValueClass(el) {
      var target = $(el);
      if (target.val()) {
        target.closest('.field-wrap').addClass('has-value');
      } else {
        target.closest('.field-wrap').removeClass('has-value');
      }
    }
    contactformInputs.each(function(idx, el) {
      setHasValueClass(el);
    })
    contactformInputs.change(function(evt) {
      setHasValueClass(evt.currentTarget);
    });
  });

  //
  //	Sendinblue Form focus
  //
  (function() {
    var contactformInputs = $('.sib-form input, .sib-form select, .sib-form textarea');
    contactformInputs.focus(function(evt) {
      $(evt.currentTarget).closest('.form__entry').addClass('has-focus');
    });
    contactformInputs.blur(function(evt) {
      $(evt.currentTarget).closest('.form__entry').removeClass('has-focus');
    });
    function setHasValueClass(el) {
      var target = $(el);
      if (target.val() || el.tagName === 'SELECT' && target.val() !== null) {
        target.closest('.form__entry').addClass('has-value');
      } else {
        target.closest('.form__entry').removeClass('has-value');
      }
    }
    contactformInputs.each(function(idx, el) {
      setHasValueClass(el);
    })
    contactformInputs.change(function(evt) {
      setHasValueClass(evt.currentTarget);
    });
  })();

  //
  // Share
  //
  $( ".share-btn" ).on( 'click', function ( e ) {
    $( '.share-flyout' ).toggleClass( "hide" );
  } );

  //
  // Carousel
  //
  $( ".blog-carousel .owl-carousel" ).each( function () {
    var $carousel = $( this ),
      $firstImage = $carousel.find( '.carousel-item .image img' ).first(),
      $navButtons,
      lastImageHeight = null,
      moveButtons = function () {
        var imageHeight = $firstImage.height();

        if ( imageHeight !== lastImageHeight ) {
          $navButtons.css( {
            top: String( imageHeight / 2 - 25 ) + 'px'
          } );

          lastImageHeight = imageHeight;
        }
      };

    $carousel.owlCarousel( {
      items: 1,
      nav: true,
      dots: false,
      loop: true,
      autoWidth: true,
      center: true
    } );

    $navButtons = $carousel.find( '.owl-prev, .owl-next' );
    $navButtons.on('click', function () {
      this.blur();
    });

    moveButtons();
    $( window ).on( 'resize', moveButtons );
  } );

  //
  // Video stage
  //
  $( '.video-stage__items' ).each(function () {
    $(this).addClass('owl-carousel').owlCarousel( {
      items: 1,
      loop: true,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      autoplay: true,
      autoplayTimeout: 7000,
      nav: false,
      dots: false,
    } );
  });

  //
  // References
  //
  $( '.references__references' ).each( function () {
    if ( 1 < $( this ).children().length ) {
      $( this ).addClass( 'owl-carousel' ).owlCarousel( {
        items: 1,
        nav: true,
        responsive: {
          1680: {
            center: true,
            autoWidth: true,
          },
        },
      } );
    }
  } );

  //
  //	Stage Slider
  //
  function StageSlider(el) {
    this.module = $(el);
    this.slider = $('.stage-slider__slides', el);

    var slides = $('.stage-slider__slide', el);
    if (slides.length <= 1) {
      this.initializeVideo(slides);
      this.slider.css('display', 'block');
      return;
    }

    this.autoplayOn = false;

    this.prepareSlides();
    this.addCarouselHandlers();

    this.slider.owlCarousel( {
      items: 1,
      nav: false,
      dots: true,
      loop: true,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      autoWidth: false,
      // autoHeight: true,
      center: true,
      autoplay: false,
      smartSpeed: 700,
      autoplayTimeout: 7000,
      slideTransition: 'ease-in-out'
    } );

    $(window).on('load', (function() {
      this.slider.trigger('play.owl.autoplay');
      this.autoplayOn = true;
    }).bind(this));
  }

  StageSlider.prototype.getPlayerOptions = function(autoplay) {
    if (autoplay) {
      return {
        controls: false,
        autoplay: true,
        muted: true,
        playsinline: true,
        ratio: '16:9',
        clickToPlay: false,
        loop: {
          active: true
        },
      };
    } else {
      return {
        controls: false,
        autoplay: false,
        muted: false,
        ratio: '16:9',
        resetOnEnd: true,
        clickToPlay: false,
        loop: {
          active: false
        },
      };
    }
  }

  StageSlider.prototype.addCarouselHandlers = function() {
    this.slider.on('changed.owl.carousel', (function(e) {
      if (this.autoplayOn) {
        this.slider.trigger('stop.owl.autoplay');
        // console.log('carousel changed start autoplay');
        this.slider.trigger('play.owl.autoplay');
      }
    }).bind(this));

    this.slider.on('initialized.owl.carousel', (function() {
      this.initializeVideo($('.owl-item', this.slider));

      this.slider.on('refreshed.owl.carousel', (function() {
        var clonedSlides = $('.cloned', this.slider);
        this.replaceVideoHTML($('.stage-slider__slide', clonedSlides));
        this.initializeVideo(clonedSlides);
      }).bind(this));
    }).bind(this));

    $('img, video', this.module).on('load', (function() {
      this.slider.data('owl.carousel').refresh();
    }).bind(this));

    // update size
    $(window).on('resize', (function() {
      setTimeout((function() {
        this.slider.data('owl.carousel').refresh();
      }).bind(this), 500);
    }).bind(this));
  }

  StageSlider.prototype.prepareSlides = function() {
    this.mediaHTML = {};
    $('.stage-slider__slide').each((function(idx, slide) {
      var mediaWrapper = $('.stage-slider__media-wrapper', slide);
      var video = $('.js-player', mediaWrapper);
      if (video.length) {
        $(slide).attr('data-slide-idx', idx);
        this.mediaHTML[idx] = mediaWrapper.html();
      }
    }).bind(this));
  }

  StageSlider.prototype.replaceVideoHTML = function(slides) {
    slides.each((function(idx, el) {
      var slide = $(el);
      var idx = $(slide).data('slideIdx');
      if (idx) {
        var mediaWrapper = $('.stage-slider__media-wrapper', slide);
        mediaWrapper.html(this.mediaHTML[idx]);
      }
    }).bind(this));
  }

  StageSlider.prototype.initializeVideo = function(selection) {
    var slider = this.slider;
    var stageSlider = this;

    // Video
    $('.stage-slider__media-wrapper > .js-player', selection).each(function(idx, el) {
      var autoplay = $(el).data('autoplay');
      var options = stageSlider.getPlayerOptions(!!autoplay);
      var player = new Plyr(el, options);
      var playerWasPlaying = false;

      var slide = $(el).closest('.stage-slider__slide');
      var owlItem = slide.parent();
      var isCloned = $(el).closest('.owl-item.cloned').length > 0;
      var playButton = $('.stage-slider__player-play', slide);
      var closeButton = $('.stage-slider__player-close', slide);

      function onTranslated() {
        // console.log('player on translated');

        if (autoplay && owlItem.hasClass('active')) {
          player.play();
        } else {
          if (autoplay) {
            player.pause();
          } else {
            player.stop();
            slide.removeClass('js-playing');
            slider.removeClass('js-playing');
          }
        }
      }
      onTranslated = onTranslated.bind(this);
      slider.on('translated.owl.carousel', onTranslated);

      if (isCloned) {
        // reset if cloned and will be removed

        function onRefresh() {
          player.stop();
          player.destroy();
          // console.log('carousel onRefresh start autoplay');
          slider.trigger('play.owl.autoplay');
          stageSlider.autoplayOn = true;
          slider.removeClass('js-playing');
          playerWasPlaying = false;
          slider.off('refresh.owl.carousel', onRefresh);
          slider.off('translated.owl.carousel', onTranslated);
          player = playerWasPlaying = slide = playButton = closeButton  = onTranslated = onRefresh = null;
          if (onTranslated) onTranslated = null;
        }
        onRefresh = onRefresh.bind(this);
        slider.on('refresh.owl.carousel', onRefresh);
      }

      player.on('ready', (function() {
        // slider.trigger('refresh.owl.carousel');
        if (autoplay && !player.playing) {
          var video = $('video', slide);
          if (video.length) {
            // firefox
            video[0].playsinline = true;
            video[0].autoplay = true;
            video[0].loop = true;
            video[0].muted = true;
            // iphone 5
            video.attr('autoplay', '');
            video.attr('loop', '');
            video.attr('muted', '');
            video.attr('playsinline', '');
          }
          player.play();
        }
        if (!autoplay) {
          var video = $('video', slide);
          video[0].muted = false;
          video.attr('muted', 'false');
        }
      }).bind(this))

      playButton.on('click', (function() {
        player.play();
        // console.log('click stop autoplay')
        slider.trigger('stop.owl.autoplay');
        stageSlider.autoplayOn = false;
        slide.addClass('js-playing');
        slider.addClass('js-playing');
      }).bind(this));

      closeButton.on('click', (function() {
        player.stop();
        slide.removeClass('js-playing');
        slider.removeClass('js-playing');
      }).bind(this));

      if (autoplay) {
        player.once('playing', (function() {
          slide.addClass('js-playing');
        }).bind(this));
      } else {
        player.on('playing', (function() {
          slider.trigger('stop.owl.autoplay');
          stageSlider.autoplayOn = false;
          slide.addClass('js-playing');
          slider.addClass('js-playing');
        }).bind(this));
        player.on('ended', (function() {
          // console.log('player ended start autoplay');
          slider.trigger('play.owl.autoplay');
          stageSlider.autoplayOn = true;
          slide.removeClass('js-playing');
          slider.removeClass('js-playing');
        }).bind(this));
        player.on('pause', (function() {
          // console.log('player pause');
          slider.trigger('play.owl.autoplay');
          stageSlider.autoplayOn = true;
          slide.removeClass('js-playing');
          slider.removeClass('js-playing');
        }).bind(this));
      }
    });
  }

  $('.stage-slider').each(function(idx, el) {
    new StageSlider(el);
  })


  /*
  *   TEAM
  *
  *   Scroll Animations
  */
  // helper http://stackoverflow.com/a/7557433/274826
  function isElementInViewport(el, offset) {
    // special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
      el = el[0];
    }
    var rect = el.getBoundingClientRect();

    return (
      (rect.top <= 0)
      ||
      (rect.bottom >= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.top <= (window.innerHeight || document.documentElement.clientHeight) - offset)
      ||
      (($(window).scrollTop() + rect.top) <= (window.innerHeight || document.documentElement.clientHeight))
      ||
      (rect.top >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight))
    );
  }

  var teams = $('.team');
  if (teams.length) {
    $(document).on('scroll', updateTeamVisibility);
    $(window).on('resize', updateTeamVisibility);
    updateTeamVisibility();
  }
  function updateTeamVisibility() {
    // requestAnimationFrame(updateTeamVisibility);
    var visiblePerson = [];
    var hiddenPerson = [];

    var visibleText = [];
    var hiddenText = [];

    var windowWidth = (window.innerWidth || document.documentElement.clientWidth);

    function removeFirstTopMargin(offset, idxPerson, text) {
      // remove whitespace from top
      if ((windowWidth >= 992 && idxPerson <= 2)
      || (windowWidth >= 576 && idxPerson <= 1)
      || (idxPerson === 0)) {
        if (windowWidth >= 1200) {
          offset -= 120 + 42 + (text ? 0 : 80);
        } else if (windowWidth >= 768) {
          offset -= 80 + 45 + (text ? 0 : 80);
        } else {
          offset -= 60 + 35 + (text ? 0 : 80);
        }
        offset = Math.max(text ? 20 : -60, offset);
      }
      return offset
    }

    // check if visible
    teams.each(function(idx, el) {
      $('.team__person-wrapper', el).each(function(idxPerson, elP) {
        var person = $(elP);
        var offset =  Math.min(.25 * window.innerHeight, 250);
        offset = removeFirstTopMargin(offset, idxPerson, false);

        if (isElementInViewport(person, offset)) {
          visiblePerson.push(person);
        } else {
          hiddenPerson.push(person);
        }

        var text = $('.person__text', person);
        if (isElementInViewport(text, removeFirstTopMargin(120, idxPerson, true))) {
          visibleText.push(text);
        } else {
          hiddenText.push(text);
        }
      })
    });

    // add classes
    visiblePerson.forEach(function(person) {
      person.addClass('js-visible');
    })
    hiddenPerson.forEach(function(person) {
      person.removeClass('js-visible');
    })
    visibleText.forEach(function(text) {
      text.addClass('js-visible');
    })
    hiddenText.forEach(function(text) {
      text.removeClass('js-visible');
    })
  }

  /*
  * Team Video Playback Hover effect
  */
  $('.person--with-video').each(function(idx, el) {
    var person = $(el);
    var video = $('video', person);
    if (video.length === 0) return;

    var timeout;

    person.hover(function() {
      video.one('playing', function() {
        person.addClass('js-playing');
      });
      video[0].play();
      if (timeout) clearTimeout(timeout);
    }, function() {
      person.removeClass('js-playing');
      timeout = setTimeout(function() {
        video[0].pause();
      }, 200);
    })
  });


  /*
  *   Partner Logos Layout
  */
  var logos = $('.partner-logos');
  logos.addClass('js-isotope-loaded');
  var partners = $('.partner-logos__partners');
  partners.isotope({
    // set itemSelector so .grid-sizer is not used in layout
    itemSelector: '.partner-logos__partner',
    percentPosition: true,
    masonry: {
      columnWidth: '.grid-sizer'
    }
  });
  $(window).on('load', function() {
    partners.isotope('layout');
  })

} )( jQuery );
